import type { TTableHeaders } from '~/misc/v-table/types';
import type { IVDropdownOption } from '~/misc/v-dropdown/types';

const MANAGER_STATS_TABLE_HEADERS: TTableHeaders = ['User', 'Opportunities Opened'];

const MANAGER_COMPANY_STATS_DATE_VALUES: (string | undefined)[] = [
  '-24 hours',
  '-48 hours',
  '-3 days',
  '-7 days',
  '-14 days',
  '-1 month',
  '-2 months',
  undefined,
];

const MANAGER_COMPANY_STATS_DATE_OPTIONS: IVDropdownOption<string, string | undefined>[] =
  MANAGER_COMPANY_STATS_DATE_VALUES.map((value: string | undefined) => ({
    value,
    label: value ? value.slice(1) : 'Any',
  }));

export { MANAGER_STATS_TABLE_HEADERS, MANAGER_COMPANY_STATS_DATE_OPTIONS };
